import { Link } from "react-router-dom";
import "../assets/css/error.css"
 
export default function ErrorPage({error}:any) {
    return(
        <div id="main-site">
            <div className="fof">
                <h1>{error.status}</h1>
                <p>در انجام عملیات با ارور زیر مواجه شدیم</p>
                <p>{JSON.stringify(error.data)}</p>
                <Link to="/" className="btn btn-primary">بازگشت به صفحه اصلی</Link>
            </div>
        </div>
    )
}